// Query Keys Factory
export const authKeys = {
  all: ['auth'] as const,
  user: () => [...authKeys.all, 'user'] as const,
  roles: () => [...authKeys.all, 'roles'] as const,
};

// Hooks
export { useLogin } from './useLogin';
export { useLogout } from './useLogout';
export { useRegister } from './useRegister';
export { useUserRoles } from './useUserRoles';
